var AttachmentMenuAction;
(function (AttachmentMenuAction) {
    AttachmentMenuAction[AttachmentMenuAction["ChangePermissions"] = 0] = "ChangePermissions";
    AttachmentMenuAction[AttachmentMenuAction["CopyLink"] = 1] = "CopyLink";
    AttachmentMenuAction[AttachmentMenuAction["Download"] = 2] = "Download";
    AttachmentMenuAction[AttachmentMenuAction["OpenInNewTab"] = 3] = "OpenInNewTab";
    AttachmentMenuAction[AttachmentMenuAction["Preview"] = 4] = "Preview";
    AttachmentMenuAction[AttachmentMenuAction["SaveToCloud"] = 5] = "SaveToCloud";
    AttachmentMenuAction[AttachmentMenuAction["ViewInProvider"] = 6] = "ViewInProvider";
    AttachmentMenuAction[AttachmentMenuAction["ConvertClassicToCloudy"] = 7] = "ConvertClassicToCloudy";
    AttachmentMenuAction[AttachmentMenuAction["ConvertCloudyToClassic"] = 8] = "ConvertCloudyToClassic";
    AttachmentMenuAction[AttachmentMenuAction["ImportCalendarEventAttachment"] = 9] = "ImportCalendarEventAttachment";
    AttachmentMenuAction[AttachmentMenuAction["MoveAttachmentToInline"] = 10] = "MoveAttachmentToInline";
    AttachmentMenuAction[AttachmentMenuAction["RefreshLink"] = 11] = "RefreshLink";
    AttachmentMenuAction[AttachmentMenuAction["IgnoreExpiration"] = 12] = "IgnoreExpiration";
})(AttachmentMenuAction || (AttachmentMenuAction = {}));
export default AttachmentMenuAction;
//# sourceMappingURL=AttachmentMenuAction.js.map